export default {
    loading: false,
    customers: null,
    customerSearchResult: null,
    totalTransactionVolume: null,
    apiKeyInfo: null,
    webhook: null,
    customerResult: null,
    customerTransactions: null,
    transactions: null,
    // What the dashboard shows: customers, transactions and volume in this currency.
    currency: "NGN",
};
